import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigateCCASS } from '../../helpers/ui.helper';
import useSelector from '../../hooks/useSelector';
import { useStatisticsColumns } from '../../modules/Insight/Ranking/RankingPage';
import { Region } from '../../shared/types';
import { ReactTable } from '../../types';
import { changePercentageColumnID } from '../table/columns';
import DLStockPeek from '../table/DLStockPeek';
import DLTable from '../table/DLTable/DLTable';

interface Props {
  level: 'category' | 'subCategory';
  region: Region;
}

const StockCategoryRankingTable: React.FC<Props> = ({ level, region }) => {
  const { t } = useTranslation();

  const { categoryStats, subCategoryStats, realtime } = useSelector(
    state => state.stock.lookupRelated
  );

  const columns: ReactTable.Column[] = useStatisticsColumns(
    realtime,
    region,
    true
  );

  const navigateCCASS = useNavigateCCASS();

  const table = React.useMemo(() => {
    return (
      <DLTable
        tableId="stock-category-ranking"
        columns={columns}
        data={(level === 'category' ? categoryStats : subCategoryStats) || []}
        renderRowSubComponent={({
          mode,
          row: {
            original: { stockCode },
          },
        }) => {
          return (
            <DLStockPeek
              stockCode={stockCode}
              mode={mode}
              onNavigateCCASS={() => navigateCCASS(stockCode, new Date())}
              region={region}
            />
          );
        }}
        defaultSortBy={[
          {
            id: changePercentageColumnID,
            desc: true,
          },
        ]}
      />
    );
  }, [categoryStats, columns, level, navigateCCASS, region, subCategoryStats]);

  return (
    <>
      {table}
      <p>
        <small>{t('* All CCASS data is 3 trading days old.')}</small>
      </p>
    </>
  );
};

export default StockCategoryRankingTable;
